import { Capacitor } from "@capacitor/core";

export const isAndroidApp = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";

export const mobileAuthReturnUrl = process.env.REACT_APP_MOBILE_AUTH_RETURN_URL;